module.exports = __webpack_public_path__ + "static/media/mirrorQuestion.3780a9da.png";